import { toast as sonnerToast } from 'sonner';

type ToastType = 'success' | 'error' | 'info' | 'warning';
type ToastOptions = {
  closeable?: boolean;
  onUndo?: () => void;
  description?: string;
};

const CRITICAL_ERROR_MESSAGES = [
  'erro ao salvar',
  'conexão perdida',
  'sessão expirada',
  'falha de conexão',
  'erro de segurança',
  'sem conexão',
  'salvamento automático falhou',
  'não foi possível salvar',
  'erro interno do servidor',
];

const NETWORK_ERROR_MESSAGES = [
  'sem conexão',
  'verifique sua rede',
  'verifique sua internet',
  'erro de conexão',
  'servidor demorou',
  'temporariamente indisponível',
];

export function toast(message: string, type: ToastType = 'info', duration: number = 4000, options?: ToastOptions) {
  const lowerMessage = message.toLowerCase();
  
  const isCriticalError = type === 'error' && CRITICAL_ERROR_MESSAGES.some(msg =>
    lowerMessage.includes(msg)
  );

  const isNetworkError = NETWORK_ERROR_MESSAGES.some(msg =>
    lowerMessage.includes(msg)
  );

  // Erros críticos ficam mais tempo visíveis
  const effectiveDuration = isCriticalError
    ? Infinity
    : isNetworkError
    ? 8000
    : type === 'error'
    ? 6000
    : duration;

  const sonnerOptions: Record<string, unknown> = {
    duration: effectiveDuration,
    closeButton: options?.closeable !== undefined ? options.closeable : true,
    ...(options?.description && { description: options.description }),
  };

  if (options?.onUndo) {
    const toastId = sonnerToast[type === 'warning' ? 'info' : type](message, {
      ...sonnerOptions,
      action: {
        label: 'Desfazer',
        onClick: () => {
          options.onUndo?.();
          sonnerToast.dismiss(toastId);
        },
      },
    });
    return;
  }

  if (type === 'warning') {
    sonnerToast.info(message, sonnerOptions);
  } else {
    sonnerToast[type](message, sonnerOptions);
  }
}

toast.success = (message: string, duration?: number, options?: ToastOptions) => toast(message, 'success', duration || 3000, options);
toast.error = (message: string, duration?: number, options?: ToastOptions) => toast(message, 'error', duration || 6000, options);
toast.info = (message: string, duration?: number, options?: ToastOptions) => toast(message, 'info', duration || 4000, options);
toast.warning = (message: string, duration?: number, options?: ToastOptions) => toast(message, 'warning', duration || 5000, options);
